import { Model } from '@vuex-orm/core'

const icons = {
  created: 'mdi-new-box',
  updated: 'mdi-square-edit-outline',
  deleted: 'mdi-delete',
}

export default class Notification extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'notifications'

  // List of all fields (schema) of the post model. `this.attr` is used
  // for the generic field type. The argument is the default value.
  static fields () {
    return {
      id: this.attr(null),
      created_at: this.string(''),
      title: this.attr(''),
      text: this.attr(''),
      task_id: this.number(null),
      action: this.attr(null),
      type: this.attr('info'/*, value => value == 'App\Notifications\Notification'*/),
    }
  }

  get icon() {
    return this.action && icons[this.action]
  }

  get type() {
    if(this._type == 'App\\Notifications\\Notification') return 'white'
    return this._type
  }

  set type(type) {
    this._type = type
  }
}